import {
  Badge,
  Offcanvas,
} from "react-bootstrap";

const ServicesDetails = ({ selectedService, show, hide }) => {
  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{selectedService?.title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {selectedService && (
          <>
            <img
              src="https://i.pravatar.cc?img=5"
              alt={selectedService.title}
              className="img-fluid rounded-3 mb-3"
            />
            <h5 className="fw-bold">{selectedService.title}</h5>
            <div
              dangerouslySetInnerHTML={{ __html: selectedService.longDescription }}
            />
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ServicesDetails;
